import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, normalizeStyle as _normalizeStyle, toDisplayString as _toDisplayString, createBlock as _createBlock, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "h-full w-full flex items-center justify-center"
}
const _hoisted_2 = { key: 1 }
const _hoisted_3 = { class: "w-full bg-white fixed top-0 p-[12px] z-10" }
const _hoisted_4 = { class: "flex items-center justify-between" }
const _hoisted_5 = {
  key: 0,
  class: "w-[100vw] overflow-scroll mt-[120px] relative"
}
const _hoisted_6 = ["src"]
const _hoisted_7 = {
  key: 1,
  class: "mt-[88px] w-[100vw] h-[250px] flex items-center justify-center"
}
const _hoisted_8 = { class: "px-[24px] mt-[24px] pb-[104px]" }
const _hoisted_9 = { class: "font-bold text-[24px]" }
const _hoisted_10 = { class: "flex justify-evenly p-[24px]" }
const _hoisted_11 = {
  key: 0,
  class: "mt-[12px]"
}
const _hoisted_12 = { class: "text-[14px] text-[#7d7f82] overflow-hidden" }
const _hoisted_13 = {
  key: 1,
  class: "mt-[12px]"
}
const _hoisted_14 = { class: "text-[14px] text-[#7d7f82] overflow-hidden" }
const _hoisted_15 = {
  key: 2,
  class: "mt-[18px] flex justify-between w-full"
}
const _hoisted_16 = { class: "flex flex-col space-y-[12px] w-full" }
const _hoisted_17 = { class: "flex justify-center text-[18px] font-bold" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("div", { class: "w-[80px] h-[2px] bg-black" }, null, -1)
const _hoisted_19 = { class: "flex justify-center text-[18px]" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_default_loader = _resolveComponent("default-loader")!
  const _component_chevron_left_icon = _resolveComponent("chevron-left-icon")!
  const _component_icon_button = _resolveComponent("icon-button")!
  const _component_the_logo = _resolveComponent("the-logo")!
  const _component_photo_icon = _resolveComponent("photo-icon")!
  const _component_scroll_menu_item = _resolveComponent("scroll-menu-item")!

  return (_ctx.isLoading)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_default_loader)
      ]))
    : (_openBlock(), _createElementBlock("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_component_icon_button, {
              class: "ml-[-6px]",
              onClick: _ctx.closeProduct
            }, {
              default: _withCtx(() => [
                _createVNode(_component_chevron_left_icon)
              ]),
              _: 1
            }, 8, ["onClick"]),
            _createVNode(_component_the_logo)
          ])
        ]),
        (_ctx.images.length > 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
              _createElementVNode("div", {
                class: "flex",
                style: _normalizeStyle(`width:${_ctx.sliderWidth}px`)
              }, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.images, (image, index) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: index,
                    class: "w-[100vw] h-[100vw]"
                  }, [
                    _createElementVNode("img", {
                      src: ('data:image/png;base64,' + image),
                      alt: "картинка",
                      class: "h-[100vw] m-auto"
                    }, null, 8, _hoisted_6)
                  ]))
                }), 128))
              ], 4)
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_7, [
              _createVNode(_component_photo_icon, {
                width: "96",
                height: "96"
              })
            ])),
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", null, [
            _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.data.Name), 1)
          ]),
          _createElementVNode("div", null, [
            _createElementVNode("div", _hoisted_10, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tabList, (tab) => {
                return (_openBlock(), _createBlock(_component_scroll_menu_item, {
                  key: tab.id,
                  text: tab.text,
                  isActive: tab.id === _ctx.currentActiveTab,
                  id: tab.id,
                  onUpdateCatalog: _ctx.updateTabHandler
                }, null, 8, ["text", "isActive", "id", "onUpdateCatalog"]))
              }), 128))
            ]),
            _createElementVNode("div", null, [
              (_ctx.data.Description && _ctx.currentActiveTab === '1')
                ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                    _createElementVNode("div", _hoisted_12, [
                      _createTextVNode(_toDisplayString(_ctx.shortDescription) + " ", 1),
                      _createElementVNode("div", {
                        class: "text-[14px] text-black font-bold mt-[6px]",
                        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.showDescription && _ctx.showDescription(...args)))
                      }, _toDisplayString(_ctx.descriptionButton), 1)
                    ])
                  ]))
                : _createCommentVNode("", true),
              (_ctx.data.Instruction && _ctx.currentActiveTab === '2')
                ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                    _createElementVNode("div", _hoisted_14, [
                      _createTextVNode(_toDisplayString(_ctx.shortInstruction) + " ", 1),
                      _createElementVNode("div", {
                        class: "text-[14px] text-black font-bold mt-[6px]",
                        onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.showInstruction && _ctx.showInstruction(...args)))
                      }, _toDisplayString(_ctx.instructionButton), 1)
                    ])
                  ]))
                : _createCommentVNode("", true),
              (_ctx.data.Prices && _ctx.currentActiveTab === '3')
                ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.data.Prices, (price) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: price.PriceType,
                        class: "flex"
                      }, [
                        _createElementVNode("div", _hoisted_16, [
                          _createElementVNode("div", _hoisted_17, _toDisplayString(price.PriceType), 1),
                          _hoisted_18,
                          _createElementVNode("div", _hoisted_19, _toDisplayString(price.Price) + " ₽ ", 1)
                        ])
                      ]))
                    }), 128))
                  ]))
                : _createCommentVNode("", true)
            ])
          ])
        ])
      ]))
}